/* SIGHTSS gallery cursor — desktop only. A white disc follows the mouse over a slider;
   right half = next, left half = previous; a click anywhere on the picture turns the slide.
   Links and buttons inside the slider keep the normal cursor and their own click. */
(function () {
  if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 10h13M11 5l5 5-5 5"/></svg>';
  var IGNORE = 'a,button,input,select,textarea,label';

  function arm(root, host, prevBtn, nextBtn) {
    if (!root || !host || !nextBtn || root.dataset.curArmed) return;
    root.dataset.curArmed = '1';
    var cur = document.createElement('span');
    cur.className = 'sx-cur';
    cur.setAttribute('aria-hidden', 'true');
    cur.innerHTML = SVG;
    host.appendChild(cur);
    var dir = 'next', on = false;
    function off() { on = false; root.classList.remove('cur-on'); }
    function move(e) {
      if (e.target.closest(IGNORE)) { off(); return; }
      if (!on) { on = true; root.classList.add('cur-on'); }
      var r = host.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      cur.style.left = x + 'px';
      cur.style.top = y + 'px';
      dir = (prevBtn && x < r.width / 2) ? 'prev' : 'next';
      cur.classList.toggle('prev', dir === 'prev');
    }
    host.addEventListener('pointermove', move);
    host.addEventListener('pointerleave', off);
    host.addEventListener('click', function (e) {
      if (!on || e.target.closest(IGNORE)) return;
      e.preventDefault();
      e.stopPropagation();
      (dir === 'prev' && prevBtn ? prevBtn : nextBtn).click();
    }, true);
  }

  function init() {
    document.querySelectorAll('.sightss-slider').forEach(function (root) {
      arm(root,
        root.querySelector('.sightss-slider__viewport'),
        root.querySelector('.sightss-slider__arrow--prev'),
        root.querySelector('.sightss-slider__arrow--next'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();